import { FETCH_ORDER_START, FETCH_ORDER_SUCCESS, FETCH_ORDER_FAILURE } from '../constants/types';
import { makeAsyncReducer } from '../utils/async_utils';

export const fetchOrder = makeAsyncReducer(
  { startType: FETCH_ORDER_START, successType: FETCH_ORDER_SUCCESS, failureType: FETCH_ORDER_FAILURE },
  { initialData: {} }
);

export const fetchOrderSelector = (state) => state.ratingReviews.fetchOrder;
